var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui segment" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("Name")]),
      _vm._v("\n    : " + _vm._s(_vm.getI18n(_vm.producer.name, "en")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("Title")]),
      _vm._v(
        "\n    : " + _vm._s(_vm.getI18n(_vm.producer.title, "en")) + "\n  "
      )
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("Description")]),
      _vm._v(
        "\n    : " +
          _vm._s(_vm.getI18n(_vm.producer.description, "en")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.producer.email != null
      ? _c("div", [
          _c("b", [_vm._v("Email :")]),
          _vm._v("\n    " + _vm._s(_vm.producer.email) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "info circle icon" }),
      _vm._v(" Identification:\n  ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }